module.exports = __webpack_public_path__ + "img/confetti-cannon.d5610793.gif";